export {
  queryResultToTable,
  getTableColumns
}


function queryResultToTable(queryResult = []) {
  const tbody = createTBody(queryResult);
  const columns = getTableColumns(queryResult);
  // fillRowspan(columns, tbody);

  return {
      tbody
  }
}

function createTBody(queryResult) {
    const trFactory = (item) => (
      item.map(row => ({
        hidden: false,
        rowspan: null,
        type: row.calculated ? 'td' : 'th',  // typeof item[column] === 'number' ? 'th' : 'td', 
        background: 'colorOffset' in row ? `rgb(255, ${row.colorOffset}, ${row.colorOffset})` : 'none',
        value: row.value
      }))
    );

    return queryResult.map(trFactory);
}

function fillRowspan(columns, tbody) {
  columns
    .reduce((cellKeyGenPrev, column, index) => {
      const columntKeyGenFactory = (column, index) => tr => [...cellKeyGenPrev(tr), `${column}-${tr[index].value}`];
      const cellKeyGen = columntKeyGenFactory(column, index);
      const getcellKey = tr => cellKeyGen(tr).join('__');

      tbody.reduce((prevTr, currentTr) => {
        if(prevTr && getcellKey(prevTr) === getcellKey(currentTr)) {
          currentTr[index].hidden = true;
          prevTr[index].rowspan = (prevTr[index].rowspan || 1) + 1;
          return prevTr;
        }

        return currentTr;
      }, null);

      return cellKeyGen;
  }, () => []);
}

function getTableColumns(queryResult) {
    return ((queryResult && queryResult[0]) || []).map(column => column.key);
}